import { render, staticRenderFns } from "./Safari.vue?vue&type=template&id=1283acd6&scoped=true"
import script from "./Safari.vue?vue&type=script&lang=js"
export * from "./Safari.vue?vue&type=script&lang=js"
import style0 from "./Safari.vue?vue&type=style&index=0&id=1283acd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1283acd6",
  null
  
)

export default component.exports